<template>

	<div class="top-div">
		<video :src="require('@/assets/video-pc/home-top.mp4')" autoplay="autoplay" loop="loop" muted="muted"
			class="videos"></video>

		<div class="sw-box">
			<!-- <h1>ACHIEVE WEALTH<span>GPT</span></h1> -->
			<h1>{{ data.title }}</h1>
			<h4>{{ data.content }}</h4>

			<div class="input-div dis-fle ali-cen jus-cen">
				<el-input v-model="input" :placeholder="$t('输入手机号/邮箱')" size="medium" class="flex-1"></el-input>
				<div class="but" @click="$nav.go('/pc/trade')">{{ $t('去交易') }}</div>
			</div>

			<div class="tip-div">
				<div class="item">
					<div class="txt-32">{{ data.money_count }}</div>
					<div class="txt-14">{{ $t('24小时交易量') }}</div>
				</div>
				<div class="item">
					<div class="txt-32">{{ data.coin_count }}</div>
					<div class="txt-14">{{ $t('加密货币种类') }}</div>
				</div>
				<div class="item">
					<div class="txt-32">{{ data.user_count }}</div>
					<div class="txt-14">{{ $t('注册用户数') }}</div>
				</div>
			</div>
		</div>

		<div class="parallax-images-wrapper">
			<div class="floating-item ball1">
				<img src="@/assets/img-pc/home_top1.png" alt="">
			</div>
			<div class="floating-item ball2">
				<img src="@/assets/img-pc/home_top2.png" alt="">
			</div>
			<div class="floating-item ball3">
				<img src="@/assets/img-pc/home_top3.png" alt="">
			</div>
			<div class="floating-item ball4">
				<img src="@/assets/img-pc/home_top4.png" alt="">
			</div>
			<div class="floating-item ball5">
				<img src="@/assets/img-pc/home_top5.png" alt="">
			</div>
			<div class="floating-item ball6">
				<img src="@/assets/img-pc/home_top6.png" alt="">
			</div>
		</div>
	</div>
</template>
<script>

export default {
	props: {
		data: {
			type: Object,
			default: () => {
				return {
					"money_count": "$75,31億",
					"coin_count": "100+",
					"user_count": "2,500萬",
				}
			}
		}
	},
	data() {
		return {
			input: '',
		};
	},
	methods: {

	},
};
</script>
<style lang="scss" scoped>
.top-div {
	position: relative;

	.parallax-images-wrapper {
		position: absolute;
		inset: 0;
		pointer-events: none;
		z-index: 2;

		.floating-item {
			position: absolute;
		}

		/* 定义动画 */
		@keyframes myfirst {
			0% {
				transform: translateY(0px);
			}

			50% {
				transform: translateY(20px);
				/* 向下移动 */
			}

			100% {
				transform: translateY(0px);
				/* 回到原位 */
			}
		}

		.ball1 {
			left: 25%;
			top: 20%;
			animation: myfirst 2s infinite;
		}

		.ball2 {
			left: 15%;
			top: 50%;
			animation: myfirst 2s infinite;
		}

		.ball3 {
			left: 25%;
			top: 80%;
			animation: myfirst 2s infinite;
		}

		.ball4 {
			left: 70%;
			top: 20%;
			animation: myfirst 2s infinite;
		}

		.ball5 {
			left: 80%;
			top: 50%;
			animation: myfirst 2s infinite;
		}

		.ball6 {
			left: 70%;
			top: 80%;
			animation: myfirst 2s infinite;
		}
	}

	.sw-box {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		color: #fff;
		max-width: 850px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		// padding-top: 110px;

		.tip-div {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 48px auto 0;
			// width: 540px;
			border: 1px solid #ffffff4d;
			background: #00000080;
			-webkit-backdrop-filter: blur(3px);
			backdrop-filter: blur(3px);
			padding: 27px 50px;
			border-radius: 100px;

			.item {
				text-align: center;
				padding: 0px 16px;

				.txt-14 {
					font-family: PingFang SC;
					color: #888;
				}
			}
		}

		.input-div {
			margin-top: 10px;

			::v-deep .el-input__inner {
				width: 304px;
				height: 54px;
				padding-left: 29px;
				border-radius: 100px;
				border: 1px solid #2c2c3e;
				background: #0a0a12;
				font-size: 18px;
				color: #fff;
			}

			.but {
				display: inline-block;
				min-width: 200px;
				padding: 0 20px;
				height: 54px;
				line-height: 54px;
				text-align: center;
				border-radius: 99px;
				font-size: 20px;
				cursor: pointer;
				margin-left: 16px;
				background: #00f0ff;
				color: #000;
			}
		}

		h4 {
			font-size: 30px;
			font-weight: 400;
			line-height: 30px;
			text-align: center;
			color: #cbd9da;
			width: 90%;
			margin: 30px auto;
		}

		h1 {
			color: #fff;
			font-size: 50px;
			line-height: 60px;
			text-align: center;
			margin: 0;

			span {
				margin-left: 6px;
				color: var(--color-txt1);
			}
		}
	}

	.videos {
		width: 100%;
		height: 100vh;
		object-fit: cover;
	}
}
</style>